$('.M-trustpilot-slider').slick({
   infinite: true,
   slidesToShow: 2,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 3000,
     prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
  responsive: [
   {
      breakpoint: 900,
      settings: {
        arrows: true,
        centerPadding: '80px',
        slidesToShow: 1
      }
   },
   {
      breakpoint: 600,
      settings: {
        arrows: true,
        centerPadding: '80px',
        slidesToShow: 1
      }
   }
  ]
  });
function initializeimagesSectionSlider() {
  const swiperContainer = document.querySelector(".mySwiper");

  if (!swiperContainer) return; // Exit if the Swiper container is not found

  // Hide the images initially
  const imagesContainer = swiperContainer.querySelector(".m-images-container");
  if (imagesContainer) {
    imagesContainer.style.visibility = "hidden";
    imagesContainer.style.opacity = "0";
  }

  // Initialize Swiper
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    autoplay: true,
    speed: 600,
    navigation: {
      nextEl: ".m-swiper-button-next",
      prevEl: ".m-swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
    on: {
      init: function () {
        // Show the images once Swiper is initialized
        if (imagesContainer) {
          imagesContainer.style.visibility = "visible";
          imagesContainer.style.opacity = "1";
        }
      },
    },
  });
}
function initializeBannerSlider() {
 var swiper = new Swiper(".uSwiper", {
      slidesPerView: 1,
      effect: "fade",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },   
    });
}

function initializecategorySlider() {
  var swiper = new Swiper(".ushopby-category-Swiper", {
    spaceBetween: 20,
    loop:true,
    slidesPerView: 6.3,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });
}
var coll = document.getElementsByClassName("collapsibleuz");
var i;
for (i = 0; i < coll.length; i++) {
 coll[i].addEventListener("click", function() {
 this.classList.toggle("active");
 var content = this.nextElementSibling;
  if (content.style.maxHeight){
    content.style.maxHeight = null;
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}
function getRandomNumber() {
    // Generate a random number between 1250 and 2500
    return Math.floor(Math.random() * (2500 - 1250 + 1)) + 1250;
}

function formatNumber(num) {
    // Format number to use a comma as a thousands separator
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function updateCounter() {
    const counterElement = document.getElementById('uvisitor-counter');
    const randomNumber = getRandomNumber();
    counterElement.textContent = formatNumber(randomNumber);
}

// Update the counter immediately and then every 2 seconds
updateCounter();
setInterval(updateCounter, 2000);






